/**
 * Service Type API
 *
 * RTK Query endpoint for fetching IATA service type codes
 */

import { baseApi } from './baseApi';

export interface ServiceType {
  code: string;
  description: string;
  category: string;
  publicDisplay: boolean;
  isActive: boolean;
}

export const serviceTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Get all service types
     * Cached for 1 hour since service types rarely change
     */
    getServiceTypes: builder.query<ServiceType[], void>({
      query: () => '/service-types',
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetServiceTypesQuery } = serviceTypeApi;
